"use client";
import { useState } from "react";

export default function ContactForm() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const validate = () => {
        const newErrors = {};
        if (!form.name.trim()) newErrors.name = "Name is required";
        if (!form.email.trim()) newErrors.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
            newErrors.email = "Email is invalid";
        if (!form.message.trim()) newErrors.message = "Message is required";
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setStatus("sending...");

        // Simulate a delay for demo
        setTimeout(() => {
            setStatus("Message sent successfully!");
            setForm({ name: "", email: "", message: "" });
        }, 1000);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <input
                    type="text"
                    name="name"
                    placeholder="Your name"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded border text-sm bg-white dark:bg-zinc-800 dark:text-white"
                />
                {errors.name && (
                    <p className="text-sm text-red-500">{errors.name}</p>
                )}
            </div>

            <div>
                <input
                    type="email"
                    name="email"
                    placeholder="Your email"
                    value={form.email}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded border text-sm bg-white dark:bg-zinc-800 dark:text-white"
                />
                {errors.email && (
                    <p className="text-sm text-red-500">{errors.email}</p>
                )}
            </div>

            <div>
                <textarea
                    name="message"
                    rows="5"
                    placeholder="Your message"
                    value={form.message}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded border text-sm bg-white dark:bg-zinc-800 dark:text-white"
                />
                {errors.message && (
                    <p className="text-sm text-red-500">{errors.message}</p>
                )}
            </div>

            <button
                type="submit"
                className="bg-primary text-white px-6 py-2 rounded hover:bg-blue-700"
            >
                Send
            </button>

            {status && (
                <p className="text-sm mt-2 text-green-600 dark:text-green-400">
                    {status}
                </p>
            )}
        </form>
    );
}
